// import { faFacebook, faInstagram, faLinkedin, faTwitter, faWeebly } from '@fortawesome/free-brands-svg-icons'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Card, Button } from '@themesberg/react-bootstrap'
import { Form, Input, Modal, Button as AntButton, Upload, Row, Col } from 'antd'
import React, { useState } from 'react'
import { useSetRecoilState } from 'recoil'
import { InboxOutlined } from '@ant-design/icons'
import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import { updateLogo, updateSettings } from '../../../services/apiCalls'
import { settingAlert, settingResponse, settingsRefresh } from '../../../states/settings'
import { dummyRequest, getHtml, getRawData } from '../../../services/utilities'

const OtherSetting = ({ data }) => {
  const [appStoreModal, setAppStoreModal] = useState(false)
  const [logoModal, setLogoModal] = useState(false)
  const [privacyModal, setPrivacyModal] = useState(false)
  const [termsModal, setTermsModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [editor, setEditor] = useState("")
  const [editor1, setEditor1] = useState("")
  const setShowAlert = useSetRecoilState(settingAlert);
  const setResponse = useSetRecoilState(settingResponse)
  const setRefresh = useSetRecoilState(settingsRefresh)
  const [form] = Form.useForm()
  const [forms] = Form.useForm()
  const [formss] = Form.useForm()
  const [file, setFile] = useState("")

  const onEditorStateChange1 = editorState => {
    setEditor1(editorState);
  };
  const onEditorStateChange = editorState => {
    setEditor(editorState);
  };

  const handleUpdateModal = (type) => {
    if (type === "privacy") {
      if (data.privacy_and_policy) {
        const contentState = getRawData(data.privacy_and_policy)
        setEditor(EditorState.createWithContent(contentState));
      }
      setPrivacyModal(true)
    } else {
      if (data.terms_of_use) {
        const contentState = getRawData(data.terms_of_use)
        setEditor1(EditorState.createWithContent(contentState));
      }
      setTermsModal(true)
    }
    setResponse({})
  }

  const onFinishUpdate = async (val) => {
    const date = new Date()
    const fd = new FormData();
    fd.append('play_store_link', val.play_store_link)
    fd.append('app_store_link', val.app_store_link)
    fd.append('downloadContent', val.downloadContent)
    fd.append('downloadDesc', val.downloadDesc)
    fd.append('file', file);
    fd.append('id', val.id);
    // setLoading(true)
    // const res = await updateSettings({ data: fd, type: "about" })
    // const value = {
    //   id: val.id,
    //   play_store_link: val.play_store_link,
    //   app_store_link: val.app_store_link,
    //   privacy_and_policy: val.type === "privacy_and_policy" && getHtml(editor),
    //   terms_of_use: val.type === "terms_of_use" && getHtml(editor1)
    // }
    setLoading(true)
    const res = await updateSettings({ data: fd, type: val.type })
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
      setAppStoreModal(false)
      setTermsModal(false)
      setPrivacyModal(false)
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
    setLoading(false)
  }
  
  const sumitLogoUpdate = async (val) => {
    const date = new Date()
    const fd = new FormData();
    fd.append('logo_title', val.logo_title)
    fd.append('logo_image', file);
    fd.append('id', val.id);
    setLoading(true)
    const res = await updateLogo({ data: fd, type: val.type })
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
      setLogoModal(false)
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
    setLoading(false)
  }
  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const handleChange = info => {
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl => {
        setFile(info.file.originFileObj)
      });
    }
  };

  return (
    <div>
      <Card border="light" className="bg-white shadow-sm mb-4">
        <Card.Body hidden>
          <h5 className="mb-4 text-primary">
            App Store Link  &nbsp;
            <Button variant="secondary" size="sm" className="text-white me-3" onClick={() => { setAppStoreModal(true) }}>
              <FontAwesomeIcon icon={faEdit} />
            </Button>
          </h5>
          {/* <a className="text-dark" href={data.play_store_link} rel="noopener noreferrer" target="_blank"><p>Play Store Link</p></a>
          <a className="text-dark" href={data.app_store_link} rel="noopener noreferrer" target="_blank"><p>Apple Store Link </p></a> */}
          <Row>
            <Col xs={12} md={12} xl={12} lg={12}>
              <img src={data.download_image} alt="hero bank" />
            </Col>
            <Col xs={12} md={12} xl={12} lg={12}>
              <h5>{data.download_content === 'undefined' ? '' : data.download_content}</h5>
              <p>{data.download_desc === 'undefined' ? '' : data.download_desc}</p>
              <AntButton type='primary'>
                <a className="mr-5 text-white" href={data.play_store_link} rel="noopener noreferrer" target="_blank"><p>Play Store Link</p></a>
              </AntButton>
              <AntButton type='danger'>
                <a className="text-white" href={data.app_store_link} rel="noopener noreferrer" target="_blank"><p>Apple Store Link </p></a>
              </AntButton>
              {/* <a className="btn btn-success  text-white" href={data.play_store_link} rel="noopener noreferrer" target="_blank"><p>Play Store Link</p></a>
              <a className="btn btn-secondary text-white" href={data.app_store_link} rel="noopener noreferrer" target="_blank"><p>Apple Store Link </p></a> */}
            </Col>
          </Row> 
        </Card.Body>
        <Card.Body>
          <h5 className="mb-4 text-primary">
            Application Logo  &nbsp;
            <Button variant="secondary" size="sm" className="text-white me-3" onClick={() => { setLogoModal(true) }}>
              <FontAwesomeIcon icon={faEdit} />
            </Button>
          </h5>
          <Row>
            <Col xs={12} md={12} xl={12} lg={12}>
              <h6>{data.logo_title}</h6>
              <img src={data.logo_image} alt="logo" />
            </Col>
          </Row> 
        </Card.Body>
      </Card>
        <Modal
          title="Update App Store Link"
          centered
          visible={appStoreModal}
          footer={null}
          onCancel={() => setAppStoreModal(false)}
        >
          <Form form={form} onFinish={onFinishUpdate} layout="horizontal" initialValues={{ play_store_link: data.play_store_link, app_store_link: data.app_store_link, downloadDesc: data.download_desc, downloadContent: data.download_content, id: data.id, type: "store" }}>
            <Form.Item label="Title" name="downloadContent">
              <Input />
            </Form.Item>  
            <Form.Item label="Description" name="downloadDesc">
              <Input.TextArea />
            </Form.Item>
            <Form.Item label="PlayStore url" name="play_store_link" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
            <Form.Item label="Apple Store url" name="app_store_link" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
            <Form.Item >
              <Upload onChange={handleChange} customRequest={dummyRequest} maxCount={1}>
                <AntButton icon={<InboxOutlined />}>Upload Image</AntButton>
              </Upload>
            </Form.Item>
            <Form.Item hidden name="id">
              <Input hidden />
            </Form.Item>
            <Form.Item hidden name="type">
              <Input />
            </Form.Item>
            <Form.Item>
              <AntButton type="primary" htmlType="submit" loading={loading}>
                Update
              </AntButton>
            </Form.Item>
          </Form>
        </Modal>
        <Modal
          title="Update App Store Link"
          centered
          visible={logoModal}
          footer={null}
          onCancel={() => setLogoModal(false)}
        >
          <Form form={form} onFinish={sumitLogoUpdate} layout="vertical" initialValues={{ logo_title: data.logo_title, id: data.id, type: 'logo' }}>
            <Form.Item label='Logo Title' name="logo_title">
              <Input />
            </Form.Item>
            <Form.Item >
              <Upload onChange={handleChange} customRequest={dummyRequest} maxCount={1}>
                <AntButton icon={<InboxOutlined />}>Upload Image</AntButton>
              </Upload>
            </Form.Item>
            <Form.Item hidden name="id">
              <Input hidden />
            </Form.Item>
            <Form.Item hidden name="type">
              <Input />
            </Form.Item>
            <Form.Item>
              <AntButton type="primary" htmlType="submit" loading={loading}>
                Update
              </AntButton>
            </Form.Item>
          </Form>
        </Modal>
    </div>
  )
}

export default OtherSetting
